import { Button, Form, Input, Modal } from "antd";
import { getDirectusClient } from "../../../lib/directus";
import { createItem } from "@directus/sdk";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 }
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 }
};

const Addcaja = (props) => {
  const [form] = Form.useForm();
console.log('props', props);

  const onFinish = async (values) => {
    let datoprocesados = 0;
    const errores = [];
    const procesados = new Set(); // Track processed serials
    const directus = await getDirectusClient();
    console.log('props', props);
    
    const inicial = values.inicial;
    const final = values.final;
    const inicialNum = parseInt(inicial);
    const finalNum = parseInt(final);
    const cantidadSeriales = Math.abs(finalNum - inicialNum) + 1;
    const largo = inicial.length;
   const largodedatos = parseInt(final) - parseInt(inicial) + 1;
    if (props.producto.cantidad < cantidadSeriales ||
        props.producto.cantidad - props.producto.seriales.length < cantidadSeriales) {
      Modal.error({
        title: "Validación de cantidad",
        content: `No hay suficientes productos disponibles.
          Cantidad solicitada: ${cantidadSeriales}
          Cantidad disponible: ${props.producto.cantidad - props.producto.seriales.length}`
      });
      return;
    }
  
  
    if (largo < props.producto.producto_detalle.grupo.codebarmin ||
        largo > props.producto.producto_detalle.grupo.codebarmax) {
      Modal.error({
        title: "Error de formato",
        content: `El tamaño del serial debe estar entre ${props.producto.producto_detalle.grupo.codebarmin} 
          y ${props.producto.producto_detalle.grupo.codebarmax} caracteres`
      });
      return;
    }
    if (props.producto.cantidad < largodedatos ||
      props.producto.cantidad - props.producto.seriales.length < largodedatos) {
    Modal.error({
      title: "Validación de tamaño de archivo",
      content: `Los seriales contienen ${largodedatos} registros y la cantidad de registros a subir son ${
        props.producto.cantidad - props.producto.seriales.length
      }!`,
    });
    return;
  }

  
    try {

      for (let numeroSerial = inicialNum; numeroSerial <= finalNum; numeroSerial++) {
        const serialActual = numeroSerial.toString().padStart(largo, "0");
        
 
        if (procesados.has(serialActual)) continue;
        
        try {
          await directus.request(
            createItem("seriales", {
              serial: serialActual,
              iccid: 0,
              min: 0,
              estado: 5,
              caja: values.caja,
              orden_compra_ingreso: props.order,
              producto: props.producto.producto_detalle.id,
              producto_odc: props.producto.id,
              bodega: props.bodegaId,
           
            })
          );
          datoprocesados++;
          procesados.add(serialActual); 
          break;
        } catch (err) {
          console.log('Error processing serial:', serialActual, err);
         
          if (err.errors?.[0]?.extensions?.code === "RECORD_NOT_UNIQUE") {
            errores.push(serialActual);
            procesados.add(serialActual); 
          } else {
    
            throw err;
          }
          break;
        }
      }

      if (errores.length > 0) {
        Modal.error({
          title: "Proceso completado con errores",
          content: (
            <div>
              <p>Se procesaron correctamente <span style={{ color: "green" }}>{datoprocesados}</span> seriales</p>
              <p>Se encontraron <span style={{ color: "red" }}>{errores.length}</span> errores:</p>
              <ul>
                {errores.map((serial, index) => (
                  <li key={index}>Serial: {serial}</li>
                ))}
              </ul>
              <p>Los errores se deben a seriales duplicados en la base de datos</p>
            </div>
          ),
          onOk: () => {
            form.resetFields();
            if (props.onSuccess) {
              props.onSuccess();
            }
          }
        });
      } else {
        Modal.success({
          title: "Proceso completado exitosamente",
          content: `Se procesaron correctamente ${datoprocesados} seriales`,
          onOk: () => {
            form.resetFields();
            if (props.onSuccess) {
              props.onSuccess();
            }
          }
        });
      }
    } catch (error) {
      console.error('Error processing serials:', error);
      Modal.error({
        title: "Error en el proceso",
        content: "Ocurrió un error al procesar los seriales"
      });
    }
  };

  const onReset = () => {
    form.resetFields();
  };

  return (
    <Form {...layout} form={form} name="control-hooks" onFinish={onFinish}>
      <Form.Item name="caja" label="Caja" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      
      <Form.Item name="inicial" label="Inicial" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      
      <Form.Item name="final" label="Final" rules={[{ required: true }]}>
        <Input />
      </Form.Item>

      <Form.Item {...tailLayout}>
        <Button type="primary" htmlType="submit">
          Procesar
        </Button>
        <Button htmlType="button" onClick={onReset}>
          Reset
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Addcaja;
